<template>
    <div id="app">
        <rkm-notification />

        <component :is="layout">
            <transition name="fade" mode="out-in">
                <router-view></router-view>
            </transition>
        </component>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
    computed: {
        layout() {
            return (this.$route.meta.layout || 'logged') + '-layout'
        }
    }
}
</script>

<style lang="scss">
    @import "assets/styles/custom.scss";
</style>